import React, { useEffect, useState } from 'react'
import { styled } from '@mui/system'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';

function Viewquiz(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [industry, setIndustry] = useState([]);
    const viewId = useParams();
    const getquizId = viewId.quizid;
    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                quizId: getquizId
            };
            const res = await fetch(`${apiUrl}/admin/getquizdetails`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
            setIndustry(data.industrylist);
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);
    return (
        <div className='width90'>
            <h2 className='pageTitle'>View Question</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" action="">
                    <div className="form-group">
                        <label className="control-label col-sm-2 label">Industry:</label>
                        <div className="col-sm-10 mt-1">
                            {industry.map((indname) =>{
                                return(<span>{indname.industry_name}, </span>)
                            })}
                            <span>{items.industryname}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Question From:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.type}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Question:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.text}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Answer Type:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.answer_type}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Question Order:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.order}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Viewquiz; 